<template>
  <div
    class="d-flex"
    :class="$vuetify.breakpoint.smAndUp ? 'pa-5' : 'py-5'"
  >
    <v-btn
      v-if="appointmentFormStepsCurr <= 9"
      :disabled="appointmentFormStepsCurr <= 1"
      @click="$emit('handleStepsNavBackward')"
      color="grey"
      elevation="0"
      large
      text
    >
      <v-icon left>mdi-chevron-left</v-icon>
      {{ $t('appointment.formCreate.actions.previous') }}
    </v-btn>

    <v-btn
      v-if="appointmentFormStepsCurr < appointmentFormStepsTotal"
      :disabled="appointmentFormStepsCurr >= appointmentFormStepsTotal"
      @click="$emit('handleStepValidations')"
      color="primary"
      elevation="0"
      class="ml-auto"
      large
    >
      {{ $t('appointment.formCreate.actions.next') }}
      <v-icon right>mdi-chevron-right</v-icon>
    </v-btn>

    <div v-if="appointmentFormStepsCurr === appointmentFormStepsTotal" class="options-menu ml-auto">
      <v-btn
        @click="$emit('validate', false)"
        :disabled="disabled"
        :loading="isLoading || isDraftLoading"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('appointment.formCreate.actions.save') }}
      </v-btn>
      <v-menu v-model="menu" :close-on-click="true" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            :disabled="isLoading || isDraftLoading"
            v-on="on"
            color="primary"
            elevation="0"
            large>
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="$emit('validate', true)" class="clickable">
            <v-icon class="grey--text" small left>mdi-file-document-outline</v-icon>
            <span class="body-2">
              {{ $t('appointment.formCreate.actions.draft') }}
            </span>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppointmentCreateActions',

  props: {
    handleStepValidations: {
      type: Function,
    },

    appointmentFormStepsCurr: {
      type: [String, Number],
    },

    appointmentFormStepsTotal: {
      type: [String, Number],
    },

    isDraftLoading: {
      type: Boolean,
    },

    isLoading: {
      type: Boolean,
    },

    disabled: {
      type: Boolean,
    }
  },

  data() {
    return {
      menu: false,
    }
  },
}
</script>

<style scoped>
.options-menu .v-btn:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.options-menu .v-menu + .v-btn {
  position: relative;
  z-index: 2;
  padding: 0;
  min-width: 40px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.3) !important;
}
</style>
